import React, { useEffect } from 'react';
import Modal from 'component/hoc/modal/Modal';
import Input from 'component/atom/forms/input/input/Input';
import TextArea from 'component/atom/forms/text-area/TextArea';
import Button from 'component/atom/forms/button/Button';
import styles from './ContactSupport.module.scss';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { usePost } from 'hooks/usePost';
import { useUserContext } from 'app-context/user/UserContext';
import { userEndpoints } from 'hooks/endpoints';

const validationSchema = yup.object({
  problemName: yup.string().required('Problem is required'),
  description: yup.string().required('Description is required'),
});

const ContactSupport = ({ isOpen, onClose, data }) => {
  const { userData } = useUserContext();
  const { mutate: contactSupport, isPending } = usePost({
    onErrorToast: 'Invalid Credentials',
  });

  const formik = useFormik({
    initialValues: {
      problemName: '',
      description: '',
      userId: userData?.authUser?.userId || '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      contactSupport(
        {
          url: userEndpoints.contactSupport(),
          data: { ...values, severity: '0' },
          requireAuth: true,
        },
        {
          onSuccess: () => {
            resetForm();
            onClose();
          },
        }
      );
    },
  });
  useEffect(() => {
    const userId = data?.data?.authUser?.userId;
    if (userId) {
      formik.setFieldValue('userId', userId);
    }
  }, [data]);
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <Modal
      title="Contact Support"
      isOpen={isOpen}
      onClose={() => {
        formik.resetForm();
        onClose();
      }}
      onSubmit={() => {}}
      buttonType="submit"
    >
      <form
        autoComplete="off"
        onSubmit={formik.handleSubmit}
        className={styles.form}
      >
        <Input
          label="Problem Name"
          placeholder="Enter Name"
          name="problemName"
          value={formik.values.problemName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.problemName}
          touched={formik.touched.problemName}
        />
        <TextArea
          label="Description"
          placeholder="Enter Description"
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.description}
          touched={formik.touched.description}
        />
        <div className={styles['form-buttons-container']}>
          <Button
            label="Cancel"
            variant="dark"
            className={styles['cancel-button']}
            onClick={onClose}
          />
          <Button
            label="Send"
            onClick={formik.handleSubmit}
            isLoading={isPending}
          />
        </div>
      </form>
    </Modal>
  );
};

export default ContactSupport;
